(() => {
  'use strict';
  if (window.leslisAiLabels) return;
  window.leslisAiLabels = true;
  const known = new Map();
  const labels = new Map();
  let queued = false;
  const label = document.querySelector('script[data-leslis-ai-label]')?.dataset.leslisAiLabel || 'AI';

  function source(url) {
    try {
      const parsed = new URL(url, location.href);
      return parsed.pathname.split('/').slice(-2).join('/') + '?v=' + (parsed.searchParams.get('v') || '');
    } catch {return '';}
  }
  function pictureSource(img) {
    if (img.parentElement?.tagName !== 'PICTURE') return null;
    const current = source(img.currentSrc || img.src);
    return [...img.parentElement.querySelectorAll('source[data-leslis-ai]')].find(node =>
      (!node.media || matchMedia(node.media).matches) &&
      node.srcset.split(',').some(candidate => source(candidate.trim().split(/\s+/)[0]) === current));
  }
  function flag(img) {
    const selected = pictureSource(img);
    if (selected) return selected.dataset.leslisAi === '1';
    if (img.hasAttribute('data-leslis-ai')) return img.dataset.leslisAi === '1';
    // PhotoSwipe clones carry the original URL rather than the Liquid attributes.
    return known.get(source(img.currentSrc || img.src)) === true;
  }
  function remember(root) {
    root.querySelectorAll('img[data-leslis-ai], source[data-leslis-ai]').forEach(node => {
      const urls = (node.srcset || '').split(',').map(value => value.trim().split(/\s+/)[0]);
      if (node.src) urls.push(node.src);
      urls.filter(Boolean).forEach(url => known.set(source(url), node.dataset.leslisAi === '1'));
    });
  }
  function position(img, badge) {
    const parent = badge.parentElement;
    const style = getComputedStyle(img);
    const bounds = img.getBoundingClientRect(), host = parent.getBoundingClientRect();
    const visible = img.complete && img.naturalWidth && bounds.width > 0 && bounds.height > 0 &&
      style.visibility !== 'hidden' && style.display !== 'none' && Number(style.opacity) > 0;
    badge.hidden = !visible;
    if (!visible) return;
    const scaleX = parent.offsetWidth ? host.width / parent.offsetWidth : 1;
    const scaleY = parent.offsetHeight ? host.height / parent.offsetHeight : 1;
    const right = Math.max(0, host.right - Math.min(bounds.right, host.right)) + 7;
    const bottom = Math.max(0, host.bottom - Math.min(bounds.bottom, host.bottom)) + 7;
    const value = `right:${right / (scaleX || 1)}px;bottom:${bottom / (scaleY || 1)}px;transform:scale(${1 / (scaleX || 1)},${1 / (scaleY || 1)})`;
    if (badge.getAttribute('style') !== value) badge.setAttribute('style', value);
  }
  function refresh() {
    queued = false;
    remember(document);
    for (const [img, badge] of labels) {
      if (!img.isConnected || !flag(img)) {badge.remove(); labels.delete(img); resize.unobserve(img);}
    }
    document.querySelectorAll('img[data-leslis-ai], .pswp__img').forEach(img => {
      if (!flag(img) || !img.parentElement || img.closest('template')) return;
      let badge = labels.get(img);
      if (!badge) {
        const parent = img.parentElement;
        if (getComputedStyle(parent).position === 'static') parent.classList.add('leslis-ai-host');
        badge = document.createElement('span');
        badge.className = 'leslis-ai-label';
        badge.textContent = 'AI';
        badge.setAttribute('role', 'img');
        badge.setAttribute('aria-label', label);
        parent.append(badge);
        labels.set(img, badge);
        resize.observe(img);
      }
      position(img, badge);
    });
  }
  function schedule() {
    if (!queued) {queued = true; requestAnimationFrame(refresh);}
  }
  const resize = new ResizeObserver(schedule);
  const observer = new MutationObserver(mutations => {
    if (mutations.some(change => {
      if (change.target.nodeType === 1 && change.target.classList.contains('leslis-ai-label')) return false;
      if (change.type === 'childList') return [...change.addedNodes, ...change.removedNodes].some(node =>
        node.nodeType === 1 && !node.classList.contains('leslis-ai-label'));
      return change.target.matches?.('img, source, picture, .pswp__zoom-wrap, .media, secondary-media');
    })) schedule();
  });
  observer.observe(document.documentElement, {subtree: true, childList: true, attributes: true,
    attributeFilter: ['src', 'srcset', 'data-leslis-ai', 'media', 'class', 'style']});
  document.addEventListener('load', event => {if (event.target.tagName === 'IMG') schedule();}, true);
  document.addEventListener('transitionend', event => {if (event.target.tagName === 'IMG') schedule();}, true);
  window.addEventListener('resize', schedule, {passive: true});
  document.addEventListener('shopify:section:load', schedule);
  schedule();
})();
